import { Link, Outlet } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export function LegalLayout() {
  const { t } = useTranslation('legal')

  const tabStyle = {
    padding: '8px 16px',
    textDecoration: 'none',
    color: 'var(--text)',
    borderBottom: '2px solid transparent',
  } as const

  const tabActive = {
    style: {
      borderBottomColor: 'var(--c-primary, #6366f1)',
      color: 'var(--c-primary, #6366f1)',
      fontWeight: 600,
    },
  }

  return (
    <div style={{ maxWidth: 860, margin: '0 auto', padding: '0 16px' }}>
      <div className="section-header">
        <div>
          <h1 style={{ fontSize: 28, fontWeight: 700, margin: '0 0 8px 0' }}>{t('title')}</h1>
          <p className="muted" style={{ margin: 0 }}>
            {t('subtitle')}
          </p>
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          gap: 16,
          marginBottom: 32,
          borderBottom: '1px solid var(--border, #e5e7eb)',
        }}
      >
        <Link to="/legal/imprint" style={tabStyle} activeProps={tabActive}>
          {t('tabs.imprint')}
        </Link>
        <Link to="/legal/privacy" style={tabStyle} activeProps={tabActive}>
          {t('tabs.privacy')}
        </Link>
      </div>

      <div className="card card-pad">
        <Outlet />
      </div>
    </div>
  )
}
